import { Box, makeStyles } from '@material-ui/core';
import React from 'react'
import GetInfoCard from 'components/GetInfoCard'
import { format24HrDateOnly } from 'lib/utils/common_utils';





const useStyles = makeStyles((theme) => ({
    partCard: {
        borderRadius: "3px",
        padding: "5px 10px",
        "& p": {
            fontSize: "14px",
            padding: "3px",
        },

    },

}))

export default function Headerdetails(props) {
    const { details, loading } = props

    const classes = useStyles()


    const infoSections = [
        [
            { keyName: "Customer", value: details?.customer ?? "-" },
            { keyName: "Base", value: details?.base ?? "-" },
        ],
        [
            { keyName: "Core Ex ID", value: details?.core_ex_id ?? "-" },

            { keyName: "Return Items", value: details?.return_item ?? "-" },
        ],
        [
            { keyName: "Created By", value: details?.created_by ?? "MP9549" },
            { keyName: "Created", value: details?.created ? format24HrDateOnly(details?.created) : "-" },

        ],
    ];

    const flexValues = [1.5, 1, 1];


    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent={"center"}
            bgcolor="#F5F5F5"
            className={classes.partCard}
            mb={"20px"}
        >
            {infoSections.map((section, index) => (
                <Box key={index} flexGrow={flexValues[index]} width="100%">
                    {section.map(({ keyName, value }) => (
                        <GetInfoCard key={keyName} keyName={keyName} value={value} />
                    ))}
                </Box>
            ))}
        </Box>
    )
}
